<div class="chip-list" id="collaborators">
  <mat-form-field fxFlex="100">
    <mat-label class="pb-4">{{label}}</mat-label>
      <mat-chip-grid #chipList aria-label="Collaborator selection">
        <mat-chip-row
          *ngFor="let item of selectedItems | async;let indx=index;"
          [selectable]="selectable"
          [removable]="permissionRemove"
          (removed)="remove(item,indx)">
          <div style="display: flex;">
            <mat-icon [ngSwitch]="item.type" class="mr-8 item-type">
              <ng-container *ngSwitchCase="memberType.User">person</ng-container>
              <ng-container *ngSwitchCase="memberType.Group">people</ng-container>
              <ng-container *ngSwitchCase="memberType.Others">account_circle</ng-container>
            </mat-icon>
            <div fxLayoutAlign="center center">
              <span>{{item.description}}</span>
              <span *ngIf="currentUser.userId == item.id && item.type == memberType.User"> ({{'ALERTS.YOU' | translate}})</span>
            </div>
            <mat-icon matChipRemove>cancel</mat-icon>
          </div>
        </mat-chip-row>
        <input
          placeholder=""
          #groupInput
          [readonly]="readonly"
          [formControl]="chipCtrl"
          [disabled]="!permissionAdd"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)"
          (focusout)="colabLostFocus()">
      </mat-chip-grid>
  </mat-form-field>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" autoActiveFirstOption >
        <mat-option *ngFor="let item of clientAutoComplete$ | async; let index = index" [value]="item">
          
            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
              <div fxLayout="row" fxLayoutAlign="flex-start center">
                <mat-icon [ngSwitch]="item.type" class="item-type">
                  <ng-container *ngSwitchCase="memberType.User" >person</ng-container>
                  <ng-container *ngSwitchCase="memberType.Group">people</ng-container>
                  <ng-container *ngSwitchCase="memberType.Others">account_circle</ng-container>
                </mat-icon>
                <span class="text-truncate">{{ item.description | titlecase}}</span><span *ngIf="currentUser.userId == item.id && item.type == memberType.User"> ({{'ALERTS.YOU' | translate}})</span>
              </div>
              
              <span class="ml-8 font-size-14 item-type string" fxHide.lt-sm>
                {{ 'COLAB-SUGGEST.TYPE.' + (item.type | titlecase) | translate}}</span>
            </div>
         </mat-option>
    </mat-autocomplete>
    <mat-hint class="error" *ngIf="chipControlFormError">{{'COLAB-SUGGEST.REQ' | translate}}</mat-hint>
  </div>
